import styled from 'styled-components'

import { ReversedWrapper } from 'components/ReversedWrapper/ReversedWrapper'
import { PositionDisplayInfo } from 'utils/userUserPositionDisplayInfos'

const OverlappingImagesWrapper = styled.div`
  display: flex;
  align-items: center;

  img + img {
    margin-left: -12px;
    z-index: 2;
  }

  img {
    width: 24px;
    height: 24px;
    z-index: 1;
  }
`

export const ProtocolLpPool = ({ displayInfo }: { displayInfo: PositionDisplayInfo }) => {
  return (
    <>
      <img src={displayInfo.protocolImgSrc} style={{ width: 24, height: 24, marginRight: 6 }} />
      <OverlappingImagesWrapper>
        <ReversedWrapper
          childX={
            <img
              style={{ width: 24, height: 24, borderRadius: '50%' }}
              src={displayInfo.position.X.iconUrl}
              alt={displayInfo.position.X.displaySymbol}
            />
          }
          childY={
            <img
              style={{ width: 24, height: 24, borderRadius: '50%' }}
              src={displayInfo.position.Y.iconUrl}
              alt={displayInfo.position.Y.displaySymbol}
            />
          }
          isReversed={displayInfo.position.configInfo.isReversedPair}
        />
      </OverlappingImagesWrapper>
    </>
  )
}
